import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { useFAQDocumentDetails } from "@modules/ECMS/MAGP/Forms/FAQ/Faq.hook";
import { decodeHTML, encodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { magpHost } from "~/Utils";
import { useWebLoginPage } from "../Login.hook";
import { fields } from "../constants";

export const AddEditWebLoginPage = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: editFaq,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditFaq,
  } = useWebLoginPage(query.get("editId") || "");

  const {
    data: FaqById,
    isLoading: isLoadingFaq,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditFaq();
    }
  }, [query.get("editId"), query.get("id")]);

  const faqFormConfig: FormConfig = {
    initialValues: {
      field_web_login_page_link: FaqById
        ? decodeHTML(FaqById.payload.field_web_login_page_link)
        : editFaq
          ? decodeHTML(editFaq?.[0]?.field_web_login_page_link)
          : "",
        field_web_login_page_title_en: FaqById ? decodeHTML(FaqById.payload.field_web_login_page_title_en) : editFaq ? decodeHTML(editFaq?.[0]?.field_web_login_page_title_en) : "",
        field_web_login_page_title_ms: FaqById
          ? decodeHTML(FaqById.payload.field_web_login_page_title_ms)
          : editFaq
            ? decodeHTML(editFaq?.[0]?.field_web_login_page_title_ms)
            : "",
        field_web_login_page_title_zh: FaqById
          ? decodeHTML(FaqById.payload.field_web_login_page_title_zh)
          : editFaq
            ? decodeHTML(editFaq?.[0]?.field_web_login_page_title_zh)
            : "",
        field_web_login_page_subtitle_en: FaqById ? decodeHTML(FaqById.payload.field_web_login_page_subtitle_en) : editFaq ? decodeHTML(editFaq?.[0]?.field_web_login_page_subtitle_en) : "",
        field_web_login_page_subtitle_ms: FaqById
          ? decodeHTML(FaqById.payload.field_web_login_page_subtitle_ms)
          : editFaq
            ? decodeHTML(editFaq?.[0]?.field_web_login_page_subtitle_ms)
            : "",
        field_web_login_page_subtitle_zh: FaqById
          ? decodeHTML(FaqById.payload.field_web_login_page_subtitle_zh)
          : editFaq
            ? decodeHTML(editFaq?.[0]?.field_web_login_page_subtitle_zh)
            : "",
        image:
          FaqById?.payload
            ? decodeHTML([
                {
                  uid: "-1",
                  name: "image.png",
                  status: "done",
                  url: FaqById?.payload?.image,
                },
              ])
            : decodeHTML([
                {
                  uid: "-1",
                  name: "image.png",
                  status: "done",
                  url: editFaq?.[0]?.image,
                },
              ]),
    },
    fields: fields.webLoginPage,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let excludedKeys: any = [];
    // for (let key in data) {
    //   if (typeof data[key] === "string" && !excludedKeys.includes(key)) {
    //     data[key] = encodeHTML(data[key]);
    //   }
    // }
    let imageKeys: any = [
      "image",
      "field_purchase_login_pop_image",
      "field_login_image",
      "filledImage",
      "googleImage",
      "showImage",
      "field_logout_image",
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "MAGP");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    const payload = {
      action: action,
      method: method,
      module: "LOGIN",
      subModule: "webLoginPage",
      type: "DEDICATED",
      application: "MAGP",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAGP",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...data,
        id: FaqById?.payload?.id || editFaq?.[0]?.id,
        published: true 
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response:any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response:any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingFaq}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Web Login`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingFaq || drilldownLoading}
        config={faqFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${magpHost}/api/web-auth/${editFaq?.[0]?.id || FaqById?.payload?.id}`,
            "UPDATE",
            "PATCH",
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </ContentWrapper>
  );
};
